<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card id="loading-block-groups-card" class="vs-con-loading__container" :collapse-action="true" title="Product Groups">

      <template v-for="(group) in workingGroups">
        <ProductSelectionCard
                              class="mb-1"
                              :key="group.id"
                              :group="group"
                              :products="products"
                              v-on:groupDeleted="groupDeleted"
                              v-on:groupUpdated="updateGroup"
        ></ProductSelectionCard>
      </template>

      <vs-button class="ml-auto mt-5 pt-2" color="primary" type="border" icon-after icon="add" @click="showNewGroupDialog = true">Add New Group</vs-button>

      <vs-prompt
        buttons-hidden
        title="Add Product Group"
        :active.sync="showNewGroupDialog">
        <div>

          <AddCompanyGroupCard :company="company"
                               v-on:groupCreated="addGroup"
          ></AddCompanyGroupCard>
        </div>
      </vs-prompt>


    </vx-card>


</template>

<script>
  import types from '@/models';
  import jsonHtml from '@/misc/jsonHtmlPrinter'
  import {productHelpers} from '@/models/helpers';
  import api from '@/http/api';
  import ProductSelectionCard from './ProductSelectionCard';
  import AddCompanyGroupCard from './AddCompanyGroupCard';

  export default {
    // mixins: [
    //   ContainerMixin,
    //   ElementMixin
    // ],
    components: {
      ProductSelectionCard,
      AddCompanyGroupCard,
    },
    mounted() {
      this.fetchAll();
    },
    data() {
      return {
        loadingCount: 0,
        types: types,
        jsonHtml: jsonHtml,
        showNewGroupDialog: false,
        helpers: productHelpers,
        groupToEdit: new types.CompanyGroup(),
        products: [ ],
        workingGroups: [],
      }
    },
    props: {
      company: {
        type: types.Company(),
        required: true,
        default: () => {
          return new types.Company()
        }
      },
    },
    watch: {
      isLoading(oldVal, newVal) {
        if (!newVal) {
          this.showSpinnerOverCard();
        } else {
          this.hideSpinnerOverCard();
        }
      },
      company(oldVal, newVal) {
        if (newVal.company_id === oldVal.company_id) return;
        this.setUpWorkingData();
        this.fetchAll();
      },
    },
    computed: {
      isLoading() {
        return this.loadingCount > 0;
      }
    },
    methods: {
      setUpWorkingData() {
        this.workingGroups = this.company.groups.map((g) => new types.CompanyGroup(g));
      },
      fetchAll() {
        this.loadingCount++;
        Promise.all([
          this.fetchProducts(),
          this.fetchGroups(),
        ]).then(() => {
          this.loadingCount--;
        });
      },
      confirmDeleteRank(rank) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          acceptText: 'DELETE',
          title: `DELETE ${rank.name}`,
          text: `Are you sure you want to delete this rank?`,
          accept: () => {
            this.deleteRank(rank);
          }
        })
      },
      async fetchProducts() {
        if (this.company.company_id === 0) return;
        const products = await api.fetchProductsForCompany(this.company.company_id);
        if (products === null) {
          this.showNotification(false, 'error fetching company products');
          return;
        }
        this.products = products;
      },
      async deleteRank(rank) {
        const success = api.deleteCompanyRank(rank);
        if (!success) {
          this.showNotification(false, 'error deleting rank');
          return;
        }

        this.showNotification(true, `Rank "${rank.name}" Deleted`);
        // update the rank list with the deleted rank removed.
        this.setRankCopies(this.workingGroups.filter((r) => r.id !== rank.id));
      },
      showSpinnerOverCard(){
        this.$vs.loading({
          container: '#loading-block-groups-card',
          scale: 0.6
        });
      },
      hideSpinnerOverCard() {
        this.$vs.loading.close('#loading-block-groups-card > .con-vs-loading')
      },
      updateGroup(newGroup) {
        console.log('group updated received @ CompanyGroupsEditorCard');
        for (let i = 0; i<this.workingGroups.length; i++) {
          let rank = this.workingGroups[i];
          if (rank.id === newGroup.id) {
            this.workingGroups[i] = newGroup;
          }
        }
        this.fetchGroups();
      },
      async fetchGroups() {
        if (this.company.company_id === 0) return;
        this.loadingCount++;

        this.workingGroups = await api.fetchCompanyGroups(this.company.company_id);

        this.loadingCount--;
      },
      addGroup(newGroup) {
        if (!newGroup) return;
        this.workingGroups.push(newGroup);
        this.showNewGroupDialog = false;
        window.location = `${window.location}`;
      },
      groupDeleted(deletedGroup) {
        if (!deletedGroup) return;
        let removeAtIndex = null;
        for (let i=0;i<this.workingGroups.length;i++) {
          if (this.workingGroups[i].id === deletedGroup.id) {
            removeAtIndex = i;
          }
        }
        this.workingGroups.splice(removeAtIndex, 1);
        this.showNewGroupDialog = false;
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    }
  }
</script>

<style lang="css" scoped>
  .fill-row-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
</style>
